import React, { useEffect, useState, useRef } from "react";
import AppTextField from "../../components/text-field";
import Lock from "../../assets/checkout/lock-iq.svg";
import Footer_V2 from "../../components/footer-v2/component";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import UIButton from "../../components/ui-button";
import HeaderV2 from "../../components/header-v2";
import AssessmentServiceApi from "../../services/assessment-api";
import ALL_CARDS from "../../assets/checkout/card-group-icon.png";
import PAYPAL_LOGO from "../../assets/checkout/paypal-icon.svg";
import CryptoJS from "crypto-js";
import "./gpay.css";
import axios from "axios";
import { createCookie, readCookie } from "../../utils/helpers";
import {
  getTokenExID,
  getTokenExScheme,
  getPaypalHostUrl,
  getChargBeeSiteName,
  getChargBeeUserName,
  paymentMode,
  getAuthorizationPaymentParams,
  getSupportedCurrency,
  getAmountInSmallestUnit,
} from "../../utils/payment-config";
import { loadScript, removeScript } from "../../utils/helpers";
import {
  isValidGuid,
  isValidString,
  validateCardHolderName,
  validateExpMonth,
  validateExpYear,
} from "../../utils/validation";
import { getPortalCD } from "../../utils/helpers";
import {
  getTokenExIframeJs,
  SOCIOPATH_TEST_ASSESSMENT_ID,
} from "../../utils/general-config";
import DropDownSelector from "../../components/drop-down-selector";
import {
  formatDateString,
  formatToTwoDecimalPlaces,
  getBrowserAndDeviceInfo,
  getMonthYearOptions,
  convertToLowerCase,
} from "../../utils/utility-functions";
import { getAssessmentDebugId } from "../../utils/assessment-debug-utils";
import Loader from "../../components/loader";
import "./checkout.css";

import { trackEvents } from "../../utils/tracking-events";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";
import useSignOut from "../../utils/sign-out";

const CheckoutIQ = ({
  funnelStep,
  createWalletPaymentIntentConnect,
  doCheckOutConnect,
  IsGuestOrPremiumUserConnect,
  userMetaConnect,
  getAssessmentAttemptByUserIdConnect,
  createHMACConnect,
}) => {
  const signOut = useSignOut();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    selectedPlan,
    email,
    assessmentId,
    userGUID,
    gender,
    assessmentAttemptId,
    countryCD,
    currencyCD,
    ipAddress,
    isValidEmail: reduxIsValidEmail,
    isAuth,
    dashboardAbTestValue,
  } = funnelStep || {};
  const [isLoading, setIsLoading] = useState(false);
  const [showApplePay, setShowApplePay] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  // DEVELOPMENT/QA/STAGING-only Checkout preview override, forwarded from
  // Plan's ?assessmentDebug=... — re-derived independently via the same
  // fail-closed gate rather than trusting the forwarded string. Used only
  // for Review Order presentation and the guest/premium redirect bypass
  // below; never for pricing, selectedPlan, payment, checkout submission,
  // or backend IDs.
  const debugAssessmentId = getAssessmentDebugId(queryParams);
  const effectiveAssessmentId = debugAssessmentId || assessmentId;
  // Skip only the guest/premium dashboard redirect below when a debug
  // override is active, mirroring Plan's isPlanDebugPreview bypass. The
  // real IsGuestOrPremiumUserConnect call still fires unconditionally —
  // only the resulting navigate() is gated.
  const isCheckoutDebugPreview = !!debugAssessmentId;
  const gatewayId = queryParams.get("gatewayId");
  const pt = isValidString(queryParams.get("pt")) ? queryParams.get("pt") : "";
  const pn = isValidString(queryParams.get("pn")) ? queryParams.get("pn") : "";
  const pg = isValidString(queryParams.get("pg")) ? queryParams.get("pg") : "";
  const personalityNameEnglishCode = isValidString(queryParams.get("pnes"))
    ? queryParams.get("pnes")
    : "";
  const currentassessmentAttemptId =
    isValidGuid(queryParams.get("assessmentAttemptId")) &&
    queryParams.get("assessmentAttemptId");
  const skuId = isValidGuid(queryParams.get("sku")) && queryParams.get("sku");
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const localeForLink = locale ? `/${locale}` : "";
  // const dashboardAbTestValue = getCookie("dashboardAbTestValue");
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD_B, currentLocale);
  const confirmationPath = PathHelper(
    APP_NAVIGATION.CONFIRMATIONIQ,
    currentLocale,
  );
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);
  const visitGuid = readCookie("visitGuid");
  const visitorGuid = readCookie("visitorGuid");
  const [hmac, setHmac] = useState("");
  const [hmacTimestamp, setHmacTimestamp] = useState("");
  const isValidEmail =
    reduxIsValidEmail === true || reduxIsValidEmail === "true";

  useEffect(() => {
    if (!userGUID) return; // exit early if no userGUID

    getAssessmentAttemptByUserIdConnect(userGUID)
      .then((res) => {
        const hasNoAssessment = !res || res.length === 0;

        if (hasNoAssessment) {
          // Condition 1: no visit & visitor
          if (!visitGuid && !visitorGuid) {
            console.log("Signing out due to no visit or visitor GUID...");
            signOut({ isNavigate: true });
            return;
          }

          // Condition 2: invalid email
          if (isValidEmail === false) {
            console.log("Signing out due to invalid email...");
            signOut({ isNavigate: true });
            return;
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching assessment attempt:", error);
      });
  }, [userGUID, visitGuid, visitorGuid, isValidEmail]);

  // const token = getCookie("jwtToken");
  const currentDate = new Date();
  const [cbInstance, setCbInstance] = useState(null);

  // For monthly plan: 14 days from now
  const after14Days = new Date(
    currentDate.getTime() + 14 * 24 * 60 * 60 * 1000,
  );

  // For annual plan: 1 year from now
  const after1Year = new Date(currentDate);
  after1Year.setFullYear(currentDate.getFullYear() + 1);

  const annualPlanTerms = `<b>${t("checkout.cancelMessage")}</b>${t(
    "checkout.paymentMessage",
  )} ${selectedPlan?.currencySymbol}${formatToTwoDecimalPlaces(
    selectedPlan?.recurringPrice,
  )} every year starting on`;
  const monthlyPlanTerms = `${t("checkout.accessDuration")}  <b>${t(
    "checkout.cancelMessage",
  )}</b> ${t("checkout.paymentMessage")} ${
    selectedPlan?.currencySymbol
  }${formatToTwoDecimalPlaces(selectedPlan?.recurringPrice)} ${t(
    "checkout.every_4_weeks",
  )}`;

  const isAnnualPlan = selectedPlan?.title === "Annual Plan";

  const terms = isAnnualPlan ? annualPlanTerms : monthlyPlanTerms;
  const termsDate = isAnnualPlan
    ? formatDateString(after1Year, t)
    : formatDateString(after14Days, t);

  const [clientSecret, setClientSecret] = useState("");
  useEffect(() => {
    if (userGUID) {
      IsGuestOrPremiumUserConnect(userGUID).then((res) => {
        if (res && res?.isPremiumOrGuestUser && !isCheckoutDebugPreview) {
          navigate(dashboardPath.next);
        }
      });
    }
  }, [userGUID, isCheckoutDebugPreview]);

  const createPaymentData = ({
    customFieldsData,
    customerSource = "",
    paypalToken = "",
    applePayToken = "",
    paymentToken = "",
    tokenizedData = {},
    expMonth = "",
    expYear = "",
  }) => {
    return {
      assessmentId: assessmentId,
      firstName: email,
      lastName: "",
      email: email,
      skuGuid: skuId,
      userGuid: userGUID,
      portalSource: getPortalCD(currentLocale),
      customFields: customFieldsData,
      customerSource,
      paypalToken,
      applePayToken,
      ipAddress: ipAddress,
      currency: currencyCD,
      assessmentAttemptId: currentassessmentAttemptId || "",
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
      maxSubUserCount: selectedPlan?.maxSubUserCount,
      paymentToken,
      locale: currentLocale,
      ccDetails: tokenizedData.token
        ? {
            cardType: tokenizedData.cardType,
            token: tokenizedData.token,
            ccExpiryMonth: expMonth,
            ccExpiryYear: expYear,
            cvv: "0",
          }
        : null, // Handle cases where there's no tokenized data
      gatewayId: gatewayId ? gatewayId : "",
    };
  };

  const MONTH_OPTIONS = getMonthYearOptions(t).month;
  const YEAR_OPTIONS = getMonthYearOptions(t).year;

  const { browser, device } = getBrowserAndDeviceInfo();

  useEffect(() => {
    trackEvents("checkoutView", {
      userGuid: userGUID,
      email: email,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      assessmentId: assessmentId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(currentLocale),
      gender: gender,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
    // Initialize Chargebee instance
    //const initializeChargebee = () =>
    {
      if (window.Chargebee) {
        const cbInstance = window.Chargebee.init({
          site: getChargBeeSiteName(), // Replace with your site name
          publishableKey: getChargBeeUserName(), // Replace with your publishable key
        });
        setCbInstance(cbInstance);
      } else {
        console.error("Chargebee library not loaded.");
      }
    }

    // Wait for the window to be fully loaded before initializing Chargebee
    // window.addEventListener("load", initializeChargebee);
  }, []);

  const useDeviceAndBrowser = () => {
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Check if the device is iOS (iPhone, iPad, iPod)
      const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

      // Check if the browser is Safari (excluding Chrome and other browsers that include "Safari")
      const isSafari = /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);

      // Set the state to true only if both conditions are true
      setIsValid(isIOS || isSafari);
    }, []); // Empty dependency array ensures this runs once when the component mounts

    return isValid;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);

  const isIOSOrSafari = useDeviceAndBrowser();
  useEffect(() => {
    const timer = setTimeout(() => {
      if (queryParams.has("pplrtrn") && queryParams.has("token")) {
        //do nothing
      } else {
        setIsLoading(false);
      }
    }, 5000);

    // Cleanup the timer when the component unmounts

    const loadApplePay = async () => {
      setIsLoading(true);
      if (!cbInstance) return; // Wait for cbInstance to be defined

      try {
        setShowApplePay(true);
        const applePayHandler = await cbInstance.load("apple-pay");
        const supportedCurrency = getSupportedCurrency(currencyCD);
        const amount =
          selectedPlan?.scheduleTypeCD === "YEAR"
            ? selectedPlan?.recurringPrice
            : selectedPlan?.unitPrice;
        const planAmount = getAmountInSmallestUnit(amount, supportedCurrency);
        const params = getAuthorizationPaymentParams(
          currencyCD,
          paymentMode.APPLEPAY,
        );
        try {
          const response = await createWalletPaymentIntentConnect(params);
          if (response) {
            const paymentIntent = {
              id: response.id,
              amount: planAmount,
              currency_code: response.currency_code,
              gateway: response.gateway,
              gateway_account_id: response.gateway_account_id,
              expires_at: response.expires_at,
              payment_method_type: response.payment_method_type,
              created_at: response.created_at,
              modified_at: response.modified_at,
              object: response.object,
              status: response.status,
            };
            // Set the payment intent
            applePayHandler.setPaymentIntent(paymentIntent);

            // Mount the payment button
            await applePayHandler.mountPaymentButton("#apple-pay-button");
            // Handle payment
            applePayHandler.handlePayment({
              success: function (result) {
                let customFieldsData = {
                  ipcountry: countryCD,
                  protalsrc: getPortalCD(currentLocale),
                  userguid: userGUID,
                };
                let subscriptionsource = "default";
                let data = createPaymentData({
                  customFieldsData,
                  customerSource: subscriptionsource,
                  paypalToken: "",
                  applePayToken: "",
                  paymentToken: result.paymentIntent.id,
                  tokenizedData: {}, // Since ccDetails is null in the original data
                  expMonth: "",
                  expYear: "",
                });
                data.paymentMethodType = paymentMode.APPLEPAY;
                // let data = {
                //   assessmentId: assessmentId,
                //   firstName: email,
                //   lastName: "",
                //   email: email,
                //   skuGuid: queryParams.get("sku"),
                //   userGuid: userGUID,
                //   portalSource: getPortalCD(),
                //   customFields: customFieldsData,
                //   customerSource: subscriptionsource,
                //   visitId: readCookie("visitGuid"),
                //   visitorId: readCookie("visitorGuid"),
                //   paypalToken: "",
                //   paymentToken: result.paymentIntent.id,
                //   ipAddress: ipAddress,
                //   currency: currencyCD,
                //   ccDetails: null,
                //   assessmentAttemptId: currentassessmentAttemptId || "",
                //   paymentMethodType: paymentMode.APPLEPAY,
                //   maxSubUserCount: selectedPlan?.maxSubUserCount,
                // };
                setIsLoading(true);
                let userMetaData = {
                  visitId: readCookie("visitGuid"),
                  visitorId: readCookie("visitorGuid"),
                  email: email,
                  device: device,
                  browser: browser,
                  paymentRequest: JSON.stringify(data),
                  isPaymentButtonClicked: true,
                  ipAddress: ipAddress,
                  userGuid: userGUID,
                };

                userMetaConnect(userMetaData)
                  .then((res) => {})
                  .catch((err) => {
                    console.log({ err });
                  });
                doCheckOutConnect(data)
                  .then((response) => {
                    if (!!response) {
                      if (
                        response === parseInt(0) ||
                        response === parseInt(-1001)
                      ) {
                        window.flag = true;
                        toast.error(
                          t("checkout.payment_declined"),
                          { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
                        );
                      } else {
                        trackEvents("paymentSuccess", {
                          userGuid: userGUID,
                          email: email,
                          eventLabel: "Page View",
                          assessmentAttemptId: assessmentAttemptId,
                          assessmentId: assessmentId,
                          countryCD: countryCD,
                          currencyCD: currencyCD,
                          portalCD: getPortalCD(currentLocale),
                          gender: gender,
                          visitId: readCookie("visitGuid"),
                          visitorId: readCookie("visitorGuid"),
                          planId: selectedPlan?.chargebeePlanId,
                          skuId: selectedPlan?.id,
                          title: selectedPlan?.title,
                          unitPrice: selectedPlan?.unitPrice,
                          recurringPrice: selectedPlan?.recurringPrice,
                          currencySymbol: selectedPlan?.currencySymbol,
                          scheduleTypeCD: selectedPlan?.scheduleTypeCD,
                        });
                        const encodedPg = encodeURIComponent(pg);
                        const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
                        navigate(confirmationUrl);
                      }
                    } else {
                      window.flag = true;
                      toast.error(
                        t("checkout.payment_declined"),
                        { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
                      );
                    }
                  })
                  .catch((error) => {
                    handlePaymentError(error);
                  })
                  .finally(() => {
                    window.flag = true;
                    setIsLoading(false); // Stop loader
                  });
              },
              error: function (error) {
                window.flag = true;
                console.log("error", error);
              },
            });
          }
        } catch (error) {
          console.error("Error creating payment intent:", error);
        }
      } catch (error) {
        console.error("Error loading Apple Pay:", error);
      }
      return () => clearTimeout(timer);
    };

    const loadGPay = async () => {
      setIsLoading(true);
      if (!cbInstance) return; // Wait for cbInstance to be defined

      try {
        const gPayHandler = await cbInstance.load("google-pay");
        const supportedCurrency = getSupportedCurrency(currencyCD);
        const amount =
          selectedPlan?.scheduleTypeCD === "YEAR"
            ? selectedPlan?.recurringPrice
            : selectedPlan?.unitPrice;
        const planAmount = getAmountInSmallestUnit(amount, supportedCurrency);
        const params = getAuthorizationPaymentParams(
          currencyCD,
          paymentMode.GOOGLEPAY,
        );
        try {
          const intent = await createWalletPaymentIntentConnect(params);
          if (intent) {
            const paymentIntent = {
              id: intent.id,
              amount: planAmount,
              currency_code: intent.currency_code,
              gateway: intent.gateway,
              gateway_account_id: intent.gateway_account_id,
              expires_at: intent.expires_at,
              payment_method_type: intent.payment_method_type,
              created_at: intent.created_at,
              modified_at: intent.modified_at,
              object: intent.object,
              status: intent.status,
            };

            // Set the payment intent
            gPayHandler.setPaymentIntent(paymentIntent);
            await gPayHandler.mountPaymentButton("#gpay-button");
            const gPayButton = document.querySelector("#gpay-button");
            gPayButton.addEventListener("click", function () {
              setIsLoading(true);
              gPayHandler.handlePayment({
                success: function (result) {
                  setIsLoading(true);
                  let customFieldsData = {
                    ipcountry: countryCD,
                    protalsrc: getPortalCD(currentLocale),
                    userguid: userGUID,
                  };
                  let subscriptionsource = "default";
                  // let data = {
                  //   firstName: email,
                  //   lastName: "",
                  //   email: email,
                  //   skuGuid: queryParams.get("sku"),
                  //   userGuid: userGUID,
                  //   portalSource: getPortalCD(),
                  //   customFields: customFieldsData,
                  //   customerSource: subscriptionsource,
                  //   visitId: readCookie("visitGuid"),
                  //   visitorId: readCookie("visitorGuid"),
                  //   paypalToken: "",
                  //   paymentToken: result.paymentIntent.id,
                  //   ipAddress: ipAddress,
                  //   currency: currencyCD,
                  //   ccDetails: null,
                  //   assessmentId: assessmentId,
                  //   assessmentAttemptId: currentassessmentAttemptId || "",
                  //   paymentMethodType: paymentMode.GOOGLEPAY,
                  //   maxSubUserCount: selectedPlan?.maxSubUserCount,
                  // };
                  let data = createPaymentData({
                    customFieldsData,
                    customerSource: subscriptionsource,
                    paypalToken: "",
                    applePayToken: "",
                    paymentToken: result.paymentIntent.id,
                    tokenizedData: {}, // Ensuring ccDetails remains null
                    expMonth: "",
                    expYear: "",
                  });
                  // Add paymentMethodType separately
                  data.paymentMethodType = paymentMode.GOOGLEPAY;

                  let userMetaData = {
                    visitId: readCookie("visitGuid"),
                    visitorId: readCookie("visitorGuid"),
                    email: email,
                    device: device,
                    browser: browser,
                    paymentRequest: JSON.stringify(data),
                    isPaymentButtonClicked: true,
                    ipAddress: ipAddress,
                    userGuid: userGUID,
                  };

                  userMetaConnect(userMetaData)
                    .then((res) => {})
                    .catch((err) => {
                      console.log({ err });
                    });
                  doCheckOutConnect(data)
                    .then((response) => {
                      if (!!response) {
                        if (
                          response === parseInt(0) ||
                          response === parseInt(-1001)
                        ) {
                          window.flag = true;
                          toast.error(
                            t("checkout.payment_declined"),
                            { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
                          );
                        } else {
                          trackEvents("paymentSuccess", {
                            userGuid: userGUID,
                            email: email,
                            eventLabel: "Page View",
                            assessmentAttemptId: assessmentAttemptId,
                            assessmentId: assessmentId,
                            countryCD: countryCD,
                            currencyCD: currencyCD,
                            portalCD: getPortalCD(currentLocale),
                            gender: gender,
                            visitId: readCookie("visitGuid"),
                            visitorId: readCookie("visitorGuid"),
                            planId: selectedPlan?.chargebeePlanId,
                            skuId: selectedPlan?.id,
                            title: selectedPlan?.title,
                            unitPrice: selectedPlan?.unitPrice,
                            recurringPrice: selectedPlan?.recurringPrice,
                            currencySymbol: selectedPlan?.currencySymbol,
                            scheduleTypeCD: selectedPlan?.scheduleTypeCD,
                          });
                          const encodedPg = encodeURIComponent(pg);
                          const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
                          navigate(confirmationUrl);
                        }
                      } else {
                        window.flag = true;
                        setIsLoading(false);
                        toast.error(
                          t("checkout.payment_declined"),
                          { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
                        );
                      }
                    })
                    .catch((error) => {
                      handlePaymentError(error);
                    })
                    .finally(() => {
                      window.flag = true;
                      setIsLoading(false); // Stop loader
                    });
                },
                error: function (error) {
                  window.flag = true;
                  setIsLoading(false);
                  toast.error(t("checkout.payment_declined"), {
                    autoClose: 5000,
                  });
                },
                cancel: function () {
                  window.flag = true;
                  setIsLoading(false);
                },
              });
            });
          }
        } catch (error) {
          setIsLoading(false);

          console.error("gpay error:", error);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("gpay error:", error);
      }
    };

    if (isIOSOrSafari) {
      loadApplePay();
    }
    loadGPay();
  }, [cbInstance]);

  const [hasClicked, setHasClicked] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [formData, setFormData] = useState({
    cardholderName: "",
    expMonth: "",
    expYear: "",
    cardNumber: "",
    cvv: "",
  });

  const [error, setError] = useState({
    cardholderNameError: "",
    expMonthError: "",
    expYearError: "",
    cvvError: "",
    cardNumberError: "",
  });

  const isError =
    error?.cardholderNameError ||
    error?.expMonthError ||
    error?.expYearError ||
    error?.cvvError ||
    error.cardNumberError;

  useEffect(() => {
    if (
      error?.cardholderNameError ||
      error?.expMonthError ||
      error?.expYearError ||
      error?.cvvError ||
      error.cardNumberError ||
      !formData.cardholderName ||
      !formData.expMonth ||
      !formData.expYear
    ) {
      setButtonDisable(true);
    } else {
      setButtonDisable(false);
    }
  }, [isError, error, formData]);

  useEffect(() => {
    if (!isAuth) {
      navigate(loginPath.next);
    }
  }, [isAuth]);

  const nameParts = formData.cardholderName.split(" ");
  const FIRST_NAME = nameParts[0];
  const lastNamePart1 = nameParts[1] || ""; // Get the second part, or an empty string if undefined
  const lastNamePart2 = nameParts[2] || "";
  const LAST_NAME = lastNamePart1 + lastNamePart2;
  const EXP_MONTH = formData.expMonth;
  const EXP_YEAR = formData.expYear;
  // Centralized error handling function
  const handlePaymentError = (error) => {
    setIsLoading(false);
    window.flag = true;

    // Extract error message from response
    let errorMessage = t("checkout.payment_declined");

    // Handle specific 422 status code for email validation
    if (error?.response?.status === 422) {
      errorMessage = t("checkout.email_required");
      setTimeout(() => {
        console.log("Signing out due to 422 error...");
        signOut({ isNavigate: true });
        toast.warn(t("checkout.payment_processing_error"));
      }, 3000);
    } else if (error?.response?.data?.ErrorMessage) {
      errorMessage = error.response.data.ErrorMessage;
    } else if (error?.message) {
      errorMessage = error.message;
    }

    toast.error(errorMessage, { autoClose: 5000 });

    // Track payment failure
    trackEvents("paymentFailure", {
      userGuid: userGUID,
      email: email,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      assessmentId: assessmentId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(currentLocale),
      gender: gender,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
  };

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   let error = "";
  //   const isExpMonthError = validateExpMonth(name.expMonth, name.expYear);
  //   const isExpYearError = validateExpYear(name.expYear, name.expMonth);
  //   if (name === "cardholderName") {
  //     error = validateCardHolderName(value);
  //   } else if (name === "expMonth") {
  //     error = validateExpMonth(value, formData.expYear);
  //   } else if (name === "expYear") {
  //     error = validateExpYear(value, formData.expMonth);
  //   }

  //   setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  //   setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  // };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let error = "";

    // First, update the formData with the new value
    const updatedFormData = { ...formData, [name]: value };

    // Validate based on the input field's name
    if (name === "cardholderName") {
      error = validateCardHolderName(value, t);
    } else if (name === "cardNumber") {
      //error = ""; //validateCardNumber(value);
    } else if (name === "cvv") {
      //error = ""; //validateCVV(value, updatedFormData.cvv);
    } else if (name === "expMonth") {
      error = validateExpMonth(value, updatedFormData.expYear, t);
    } else if (name === "expYear") {
      error = validateExpYear(value, updatedFormData.expMonth, t);
    }

    // Set the individual error
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));

    // Validate the combination of month and year after updating formData
    if (name === "expMonth" || name === "expYear") {
      const expMonthError = validateExpMonth(
        updatedFormData.expMonth,
        updatedFormData.expYear,
        t,
      );
      const expYearError = validateExpYear(
        updatedFormData.expYear,
        updatedFormData.expMonth,
        t,
      );

      // Set the combination errors
      setError((prevError) => ({
        ...prevError,
        expMonthError,
        expYearError,
      }));
    }

    // Finally, update the formData state
    setFormData(updatedFormData);
  };

  useEffect(() => {
    //if (!!readCookie("jwtToken"))
    {
      let isPayPalPaymentCancel = queryParams.get("cancel") || "";
      var currentUrl = new URL(window.location.href);
      if (!!isPayPalPaymentCancel && isPayPalPaymentCancel === "true") {
        if (window.location.href.indexOf("cancel") > -1) {
          currentUrl.searchParams.delete("token");
          currentUrl.searchParams.delete("ba_token");
          currentUrl.searchParams.delete("cancel");
          window.history.pushState({}, "", currentUrl);
        }
        //TODO: show try again error
      } else {
        if (
          queryParams.has("pplrtrn") &&
          queryParams.has("token") &&
          !queryParams.has("ispaypalsuccess")
        ) {
          var currentUrl = new URL(window.location.href);
          if (window.location.href.indexOf("ispaypalsuccess=true") <= 0) {
            currentUrl.searchParams.append("ispaypalsuccess", "true");
            window.history.pushState({}, "", currentUrl);
          }
          setIsLoading(true);
          excecutePaypalProcess(queryParams.get("token"));
        }
      }
    }
  }, []);

  useEffect(() => {
    createHmac();
  }, []);

  useEffect(() => {
    if (!hmac) {
      return;
    }

    const initializeTokenEx = async () => {
      await loadScript(getTokenExIframeJs());
    };

    initializeTokenEx();

    return () => {
      removeScript(getTokenExIframeJs());
    };
  }, [hmac]);

  const createHmac = async () => {
    try {
      const timestamp = getUTCTimeStamp();
      const data = {
        origin: window.location.origin,
        timestamp,
      };
      const res = await createHMACConnect(data);
      if (res?.hmac) {
        setHmac(res.hmac);
        setHmacTimestamp(timestamp);
        return res.hmac;
      }

      return null;
    } catch (err) {
      console.log({ err });
      return null;
    }
  };

  const getUTCTimeStamp = () => {
    var date = new Date();
    return (
      date.getUTCFullYear() +
      ("0" + (date.getUTCMonth() + 1)).slice(-2) +
      ("0" + date.getUTCDate()).slice(-2) +
      ("0" + date.getUTCHours()).slice(-2) +
      ("0" + date.getUTCMinutes()).slice(-2) +
      ("0" + date.getUTCSeconds()).slice(-2)
    );
  };

  window.validateIframe = (data) => {
    if ((data && !data.isValid) || (data && data.cardType === "unknown")) {
      setError((prevError) => ({
        ...prevError,
        cardNumberError:
          !data.isValid || data.cardType === "unknown"
            ? t("checkout.invalid_card_number")
            : "",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        cardNumberError: "",
      }));
    }
    if (data && !data.isCvvValid) {
      setError((prevError) => ({
        ...prevError,
        cvvError: !data.isCvvValid ? t("checkout.invalid_cvv_text") : "",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        cvvError: "",
      }));
    }
  };

  // TokenEx binds its tokenize listener to the single element with id
  // "btnSubmit" (see tokenEXscript.js), so the second CTA delegates its click
  // to that button instead of duplicating the id.
  const handleReviewOrderCtaClick = () => {
    document.getElementById("btnSubmit")?.click();
  };

  const onPaymentClickHandler = (e) => {
    e.preventDefault(); // Prevent default form submission

    setHasClicked(true);

    const { cardholderName, cardNumber, cvv, expMonth, expYear } = formData;
    const isCardholderNameError = validateCardHolderName(
      cardholderName.trim(),
      t,
    );
    const isExpMonthError = validateExpMonth(expMonth, expYear, t);
    const isExpYearError = validateExpYear(expYear, expMonth, t);

    // const isCvvError = window.validateIframe(cvv);
    // const isCardNumberError = window.validateIframe(cardNumber);

    // let hasError = false;

    if (isCardholderNameError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({
        ...prevError,
        cardholderNameError: isCardholderNameError,
      }));
      // hasError = true;
    } else {
      setError((prevError) => ({ ...prevError, cardholderNameError: "" }));
    }

    if (isExpMonthError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({
        ...prevError,
        expMonthError: isExpMonthError,
      }));
      // hasError = true;
    } else {
      setError((prevError) => ({ ...prevError, expMonthError: "" }));
    }

    if (isExpYearError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({ ...prevError, expYearError: isExpYearError }));
      // hasError = true;
    } else {
      setError((prevError) => ({ ...prevError, expYearError: "" }));
    }

    if (
      !isCardholderNameError &&
      !isExpMonthError &&
      !isExpYearError &&
      !buttonDisable
    ) {
      // !isError
      // setIsLoading(true);
      window.inititatePayment = (tokenizedData) => {
        let customFieldsData = {
          ipcountry: countryCD,
          protalsrc: getPortalCD(currentLocale),
          userguid: userGUID,
        };

        // let data = {
        //   assessmentId: assessmentId,
        //   firstName: FIRST_NAME,
        //   lastName: LAST_NAME || "",
        //   email: email,
        //   skuGuid: queryParams.get("sku"),
        //   userGuid: userGUID,
        //   portalSource: getPortalCD(),
        //   customFields: customFieldsData,
        //   customerSource: "",
        //   paypalToken: "",
        //   applePayToken: "",
        //   ipAddress: ipAddress,
        //   currency: currencyCD,
        //   assessmentAttemptId: currentassessmentAttemptId || "",
        //   visitId: readCookie("visitGuid"),
        //   visitorId: readCookie("visitorGuid"),
        //   maxSubUserCount: selectedPlan?.maxSubUserCount,
        //   paymentToken: "",
        //   ccDetails: {
        //     cardType: tokenizedData.cardType,
        //     token: tokenizedData.token,
        //     ccExpiryMonth: EXP_MONTH,
        //     ccExpiryYear: EXP_YEAR,
        //     cvv: "0",
        //   },
        // };
        let data = createPaymentData({
          customFieldsData,
          customerSource: "",
          paypalToken: "",
          applePayToken: "",
          paymentToken: "",
          tokenizedData: {
            cardType: tokenizedData?.cardType,
            token: tokenizedData?.token,
          },
          expMonth: EXP_MONTH,
          expYear: EXP_YEAR,
        });
        data.firstName = FIRST_NAME;
        data.lastName = LAST_NAME || "";
        let userMetaData = {
          visitId: readCookie("visitGuid"),
          visitorId: readCookie("visitorGuid"),
          email: email,
          device: device,
          browser: browser,
          paymentRequest: JSON.stringify(data),
          isPaymentButtonClicked: true,
          ipAddress: ipAddress,
          userGuid: userGUID,
        };

        userMetaConnect(userMetaData)
          .then((res) => {})
          .catch((err) => {
            console.log({ err });
          });
        setIsLoading(true);
        doCheckOutConnect(data)
          .then((response) => {
            if (!!response) {
              // response = 0;

              if (response === parseInt(0) || response === parseInt(-1001)) {
                window.flag = true;
                toast.error(
                  t("checkout.payment_declined"),
                  { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
                );
              } else {
                trackEvents("paymentSuccess", {
                  userGuid: userGUID,
                  email: email,
                  eventLabel: "Page View",
                  assessmentAttemptId: assessmentAttemptId,
                  assessmentId: assessmentId,
                  countryCD: countryCD,
                  currencyCD: currencyCD,
                  portalCD: getPortalCD(currentLocale),
                  gender: gender,
                  visitId: readCookie("visitGuid"),
                  visitorId: readCookie("visitorGuid"),
                  planId: selectedPlan?.chargebeePlanId,
                  skuId: selectedPlan?.id,
                  title: selectedPlan?.title,
                  unitPrice: selectedPlan?.unitPrice,
                  recurringPrice: selectedPlan?.recurringPrice,
                  currencySymbol: selectedPlan?.currencySymbol,
                  scheduleTypeCD: selectedPlan?.scheduleTypeCD,
                });
                createCookie(
                  "iqCardFirstName",
                  encodeURIComponent(FIRST_NAME),
                  1,
                ); ///keep
                const encodedPg = encodeURIComponent(pg);
                const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
                navigate(confirmationUrl);
              }
            } else {
              window.flag = true;
              toast.error(
                t("checkout.payment_declined"),
                { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
              );
            }
          })
          .catch((error) => {
            console.error("doCheckOutConnect failed", error);
            handlePaymentError(error);
          })
          .finally(() => {
            window.flag = true;
            setIsLoading(false); // Stop loader
          });
      };
    } else {
      setIsLoading(false);
    }
  };

  //PAYPAL IMPLEMENTATION
  const paypalClickInProgress = useRef(false);

  const createPaypalAccessToken = async () => {
    try {
      const response =
        await AssessmentServiceApi.getPaypalAccessToken(userGUID);
      await createBillingAgreementToken(response.accessToken);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error(t("checkout.payment_declined"), { autoClose: 5000 });
        setIsLoading(false); // Stop loader
      }
    } finally {
      paypalClickInProgress.current = false;
    }
  };

  const createBillingAgreementToken = (accessToken) => {
    let returnUrl = window.location.href + "&pplrtrn=true";
    let cancelUrl = window.location.href + "&cancel=true";
    let domainSubscription = "Insightfultraits Subscription";
    var data = JSON.stringify({
      description: domainSubscription,
      payer: {
        payment_method: "Paypal",
        payer_info: {
          email: email,
        },
      },
      plan: {
        type: "MERCHANT_INITIATED_BILLING",
        merchant_preferences: {
          return_url: returnUrl,
          cancel_url: cancelUrl,
          accepted_pymt_type: "INSTANT",
          skip_shipping_address: true,
          immutable_shipping_address: true,
        },
      },
    });
    let access_token = "Bearer " + accessToken;
    var config = {
      method: "post",
      url: getPaypalHostUrl() + "/v1/billing-agreements/agreement-tokens",
      headers: {
        "Content-Type": "application/json",
        Authorization: access_token,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        localStorage.setItem("pptoken_id", response.data.token_id); //pp=>PayPal
        window.location = response.data.links[0].href;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const excecutePaypalProcess = (token) => {
    let subscriptionsource = "default";
    let uploadTime = new Date().toUTCString();
    let customFieldsData = {
      ipcountry: countryCD,
      protalsrc: getPortalCD(currentLocale),
      userguid: userGUID,
    };
    let data = createPaymentData({
      customFieldsData,
      customerSource: subscriptionsource,
      paypalToken: token,
      applePayToken: "",
      paymentToken: "",
      tokenizedData: {}, // Ensuring ccDetails remains null
      expMonth: "",
      expYear: "",
    });
    // let data = {
    //   assessmentId: assessmentId,
    //   firstName: email,
    //   lastName: "",
    //   email: email,
    //   skuGuid: queryParams.get("sku"),
    //   userGuid: userGUID,
    //   portalSource: getPortalCD(),
    //   customFields: customFieldsData,
    //   customerSource: subscriptionsource,
    //   paypalToken: token,
    //   applePayToken: "",
    //   ipAddress: ipAddress,
    //   currency: currencyCD,
    //   visitId: readCookie("visitGuid"),
    //   visitorId: readCookie("visitorGuid"),
    //   maxSubUserCount: selectedPlan?.maxSubUserCount,
    //   ccDetails: null,
    //   paymentToken: "",
    //   assessmentAttemptId: currentassessmentAttemptId || "",
    // };
    let userMetaData = {
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
      email: email,
      device: device,
      browser: browser,
      paymentRequest: JSON.stringify(data),
      isPaymentButtonClicked: true,
      ipAddress: ipAddress,
      userGuid: userGUID,
    };

    userMetaConnect(userMetaData)
      .then((res) => {})
      .catch((err) => {
        console.log({ err });
      });
    setIsLoading(true);
    doCheckOutConnect(data)
      .then((response) => {
        setIsLoading(true);
        if (!!response) {
          if (response === parseInt(0) || response === parseInt(-1001)) {
            window.flag = true;
            toast.error(
              t("checkout.payment_declined"),
              { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
            );
          } else {
            trackEvents("paymentSuccess", {
              userGuid: userGUID,
              email: email,
              eventLabel: "Page View",
              assessmentAttemptId: assessmentAttemptId,
              assessmentId: assessmentId,
              countryCD: countryCD,
              currencyCD: currencyCD,
              portalCD: getPortalCD(currentLocale),
              gender: gender,
              visitId: readCookie("visitGuid"),
              visitorId: readCookie("visitorGuid"),
              planId: selectedPlan?.chargebeePlanId,
              skuId: selectedPlan?.id,
              title: selectedPlan?.title,
              unitPrice: selectedPlan?.unitPrice,
              recurringPrice: selectedPlan?.recurringPrice,
              currencySymbol: selectedPlan?.currencySymbol,
              scheduleTypeCD: selectedPlan?.scheduleTypeCD,
            });
            const encodedPg = encodeURIComponent(pg);
            const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
            navigate(confirmationUrl);
          }
        } else {
          window.flag = true;
          toast.error(
            t("checkout.payment_declined"),
            { autoClose: 5000 }, // 5000 milliseconds = 5 seconds
          );
        }
      })
      .catch((error) => {
        // console.error("doCheckOutConnect failed", error);
        handlePaymentError(error);
      })
      .finally(() => {
        window.flag = true;
        // setIsLoading(false); // Stop loader
      });
  };
  const paypalHandler = () => {
    if (paypalClickInProgress.current) {
      return;
    }

    paypalClickInProgress.current = true;

    setIsLoading(true);
    createPaypalAccessToken();
  };

  const isSociopathTest =
    !!effectiveAssessmentId &&
    convertToLowerCase(effectiveAssessmentId) ===
      convertToLowerCase(SOCIOPATH_TEST_ASSESSMENT_ID);

  const FEATURES_LIST = [
    { id: 1, text: t("checkout_v2.perk_report") },
    { id: 2, text: t("checkout_v2.perk_tests") },
    {
      id: 3,
      text: `${t("checkout_v2.perk_invite_prefix")} ${selectedPlan?.maxSubUserCount} ${t("checkout_v2.perk_invite_suffix")}`,
    },
  ];

  return (
    <>
      <div className="min-h-screen flex flex-col bg-surface-card">
        <Loader isLoading={isLoading} />

        {/* TokenEx hidden fields */}
        <input type="hidden" id="txOrigin" value={window.location.origin} />
        <input type="hidden" id="txID" value={getTokenExID()} />
        <input type="hidden" id="txTokenScheme" value={getTokenExScheme()} />
        <input type="hidden" id="txHMAC" value={hmac} />
        <input type="hidden" id="txTimestamp" value={hmacTimestamp} />

        {/* Desktop header */}
        <HeaderV2 currentStep={2} />

        <main className="max-w-[1180px] mx-auto px-[clamp(16px,4vw,40px)] pt-[clamp(24px,5vw,48px)] pb-20">
          {/* Hero */}
          <div className="text-center max-w-[640px] mx-auto mb-[clamp(24px,3vw,40px)]">
            <div className="text-[0.78rem] font-bold tracking-[0.14em] uppercase text-brand-orange-hover">
              {t("checkout_v2.last_step_label")}
            </div>
            <h1 className="font-bold tracking-[-0.03em] leading-[1.08] text-[clamp(1.6rem,4vw,2.4rem)] mt-2 mb-0">
              {t("checkout_v2.heading")}
            </h1>
          </div>

          {/* Two-column grid */}
          <div className="flex flex-wrap gap-[clamp(20px,3vw,32px)] items-start">
            {/* ===== LEFT: Payment form ===== */}
            <div className="flex-[1_1_380px] min-w-0 flex flex-col gap-4">
              {/* Total due */}
              <div className="bg-white border border-[rgba(43,35,51,0.07)] rounded-[18px] px-5 py-4 shadow-[0_12px_30px_-22px_rgba(43,35,51,0.5)] flex items-center justify-between">
                <span className="font-bold text-[1.05rem]">
                  {t("checkout_v2.totalDue")}
                </span>
                <span className="font-bold text-[1.5rem] text-perk-orange">
                  {selectedPlan?.currencySymbol}
                  {selectedPlan?.scheduleTypeCD === "YEAR"
                    ? formatToTwoDecimalPlaces(selectedPlan?.recurringPrice)
                    : formatToTwoDecimalPlaces(selectedPlan?.unitPrice)}
                </span>
              </div>

              {/* Express checkout */}
              <div className="bg-white border border-[rgba(43,35,51,0.07)] rounded-[18px] px-5 py-4 shadow-[0_12px_30px_-22px_rgba(43,35,51,0.5)]">
                <div className="font-bold text-[0.92rem] text-text-body mb-3">
                  {t("checkout.express_checkout")}
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {/* PayPal */}
                  <div
                    className="flex items-center justify-center py-[13px] rounded-[12px] cursor-pointer bg-white border-[1.5px] border-[rgba(43,35,51,0.14)] hover:bg-surface-hover transition-colors"
                    onClick={paypalHandler}
                  >
                    <img
                      src={PAYPAL_LOGO}
                      className="w-[58px] h-auto"
                      alt="PayPal"
                    />
                  </div>

                  {/* Apple Pay */}
                  {showApplePay && (
                    <div
                      id="apple-pay-button"
                      className="w-full h-[50px] rounded-[12px] cursor-pointer"
                    />
                  )}

                  {/* Google Pay */}
                  <div
                    id="gpay-button"
                    className="w-full h-[50px] rounded-[12px] cursor-pointer flex items-center justify-center"
                  />
                </div>
              </div>

              {/* Card information */}
              <div className="bg-white border border-[rgba(43,35,51,0.07)] rounded-[18px] px-5 py-5 shadow-[0_12px_30px_-22px_rgba(43,35,51,0.5)]">
                <div className="flex items-center justify-between mb-4">
                  <span className="font-bold text-[0.92rem] text-text-body">
                    {t("checkout.card_information")}
                  </span>
                  <img
                    src={ALL_CARDS}
                    className="h-[14px] w-auto"
                    alt="accepted cards"
                  />
                </div>

                <div className="flex flex-col gap-[14px]">
                  <AppTextField
                    id="checkout-c-cardholder-name"
                    label={t("checkout_v2.cardholder_name")}
                    name="cardholderName"
                    placeholder={t("checkout.cardholder_placeholder")}
                    value={formData.cardholderName}
                    onChange={handleInputChange}
                    error={error.cardholderNameError}
                    pattern="[A-Za-z\s]+"
                    className="w-full"
                  />

                  {/* Card number (TokenEx) */}
                  <div>
                    <div className="text-[0.8rem] font-bold text-text-body mb-[6px]">
                      {t("checkout_v2.card_number")}
                    </div>
                    <div
                      name="cardNumber"
                      id="tokenExIframeDiv"
                      className="h-[46px] border-[1.5px] border-[rgba(43,35,51,0.14)] w-full rounded-[11px] pl-3"
                    />
                    {error.cardNumberError && (
                      <p className="mt-1 text-[12px] text-red-600">
                        {error.cardNumberError}
                      </p>
                    )}
                  </div>

                  {/* Expiry + CVV row */}
                  <div className="flex gap-3">
                    <div className="flex-[2_1_0] min-w-0">
                      <div className="text-[0.8rem] font-bold text-text-body mb-[6px]">
                        {t("checkout_v2.exp_month")}
                      </div>
                      <div className="flex gap-2">
                        <DropDownSelector
                          id="checkout-c-exp-month"
                          name="expMonth"
                          placeholder={t("checkout.exp_month_placeholder")}
                          value={formData.expMonth}
                          options={MONTH_OPTIONS}
                          onChange={handleInputChange}
                          error={error.expMonthError}
                          className="flex-1"
                        />
                        <DropDownSelector
                          id="checkout-c-exp-year"
                          name="expYear"
                          placeholder={t("checkout.exp_year_placeholder")}
                          value={formData.expYear}
                          options={YEAR_OPTIONS}
                          onChange={handleInputChange}
                          error={error.expYearError}
                          className="flex-1"
                        />
                      </div>
                    </div>
                    <div className="flex-[1_1_0] min-w-0">
                      <div className="text-[0.8rem] font-bold text-text-body mb-[6px]">
                        {t("checkout.cvv")}
                      </div>
                      <div
                        name="cvv"
                        id="card-cvv-element"
                        className="h-[46px] border-[1.5px] border-[rgba(43,35,51,0.14)] rounded-[11px] pl-3"
                      />
                      {error.cvvError && (
                        <p className="mt-1 text-[12px] text-red-600">
                          {error.cvvError}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* CTA */}
                <UIButton
                  id="btnSubmit"
                  variant="block"
                  onClick={onPaymentClickHandler}
                  disabled={buttonDisable || isLoading}
                  className="mt-[18px] shadow-[0_14px_30px_-14px_rgba(255,140,107,0.7)]"
                >
                  {t("checkout_v2.get_my_report_cta")}
                </UIButton>

                {/* Security line */}
                <div className="flex items-center gap-2 mt-4 text-text-muted text-[0.8rem] font-semibold">
                  <img src={Lock} alt="" width={14} height={14} />
                  {t("checkout_v2.paymentSecurity")}
                </div>
              </div>
            </div>

            {/* ===== RIGHT: Review order ===== */}
            <div className="flex-[1_1_320px] min-w-0 bg-card-preview-gradient rounded-[22px] px-[clamp(22px,3vw,30px)] py-[clamp(22px,3vw,28px)]">
              <div className="font-bold text-[1.15rem]">
                {t("checkout_v2.review_order")}
              </div>

              {/* Order item */}
              <div className="flex items-start justify-between mt-4 pb-[14px] border-b border-[rgba(43,35,51,0.1)]">
                <div>
                  <div className="font-bold text-[1rem]">
                    {selectedPlan?.title}
                  </div>
                  <div className="text-[0.84rem] text-text-muted mt-[2px]">
                    {selectedPlan?.description}
                  </div>
                  <div className="text-[0.84rem] text-text-muted mt-[px]">
                    {t("checkout_v2.description_sub")}
                  </div>
                </div>
                <div className="font-bold text-[1.1rem] flex-none ml-4">
                  {selectedPlan?.currencySymbol}
                  {selectedPlan?.scheduleTypeCD === "YEAR"
                    ? formatToTwoDecimalPlaces(selectedPlan?.recurringPrice)
                    : formatToTwoDecimalPlaces(selectedPlan?.unitPrice)}
                </div>
              </div>

              {/* Perks */}
              <div className="flex flex-col gap-[11px] mt-4">
                {FEATURES_LIST.map((feature) => (
                  <div
                    key={feature.id}
                    className="flex items-center gap-[10px] text-[0.92rem] font-semibold text-text-body"
                  >
                    <span className="flex-none w-[20px] h-[20px] rounded-full bg-status-success-text text-white flex items-center justify-center text-[0.68rem]">
                      ✓
                    </span>
                    {feature.text}
                  </div>
                ))}
                <div className="flex items-center gap-[10px] text-[0.92rem] font-semibold text-text-body">
                  <span className="flex-none w-[20px] h-[20px] rounded-full bg-status-success-text text-white flex items-center justify-center text-[0.68rem]">
                    ✓
                  </span>
                  {t("checkout_v2.perk_money_back")}
                </div>
              </div>

              {/* Total */}
              <div className="flex items-center justify-between mt-[18px] pt-4 border-t border-[rgba(43,35,51,0.1)]">
                <span className="font-bold text-[1.05rem]">
                  {t("checkout_v2.totalDue")}
                </span>
                <span className="font-bold text-[1.4rem] text-perk-orange">
                  {selectedPlan?.currencySymbol}
                  {selectedPlan?.scheduleTypeCD === "YEAR"
                    ? formatToTwoDecimalPlaces(selectedPlan?.recurringPrice)
                    : formatToTwoDecimalPlaces(selectedPlan?.unitPrice)}
                </span>
              </div>

              {/* CTA */}
              <UIButton
                id="btnSubmit"
                variant="block"
                onClick={onPaymentClickHandler}
                disabled={buttonDisable || isLoading}
                className="mt-4 shadow-[0_14px_30px_-14px_rgba(255,140,107,0.7)]"
              >
                {t("checkout_v2.get_my_report_cta")}
              </UIButton>

              {/* Fine print */}
              <p className="text-[0.72rem] text-text-muted leading-[1.5] mt-3 mb-0">
                {t("checkout.acceptanceMessage")}{" "}
                <Link
                  to={`https://insightfultraits.com${localeForLink}/terms-conditions/`}
                  className="text-brand-orange-hover"
                  target="_blank"
                >
                  {t("footer.terms_and_conditions")}
                </Link>
                ,{" "}
                <Link
                  to={`https://insightfultraits.com${localeForLink}/refunds-cancellations/`}
                  className="text-brand-orange-hover"
                  target="_blank"
                >
                  {t("footer.refund_policy")}
                </Link>{" "}
                {t("account.and")}{" "}
                <Link
                  to={`https://insightfultraits.com${localeForLink}/privacy-policy/`}
                  className="text-brand-orange-hover"
                  target="_blank"
                >
                  {t("footer.privacy_policy")}
                </Link>
                {". "}
                <span dangerouslySetInnerHTML={{ __html: terms }} />{" "}
                <strong>{termsDate}</strong>.{" "}
                {t("checkout.customerSupportMessage")}{" "}
                <Link
                  to="mailto:support@insightfultraits.com"
                  className="text-brand-orange-hover"
                >
                  {t("plan.support_email")}
                </Link>
              </p>
            </div>
          </div>
        </main>
        <Footer_V2 />
      </div>
    </>
  );
};

export default CheckoutIQ;
